import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { ResumePetisSimulationProposalClientResponse } from '../@types/ResumePetisSimulationProposal'

type Store = {
  resumePetisSimulationProposal: ResumePetisSimulationProposalClientResponse | null
  setResumePetisSimulationProposal: (
    resumePetisSimulationProposal: ResumePetisSimulationProposalClientResponse,
  ) => void
}

export const useResumePetisSimulationProposalStore = create<Store>()(
  devtools(
    (set) => ({
      resumePetisSimulationProposal: null,
      setResumePetisSimulationProposal: (resumePetisSimulationProposal) =>
        set({ resumePetisSimulationProposal }),
    }),
    { name: 'ResumePetisSimulationProposalStore' },
  ),
)
